"use strict";
// todo: Dedup some of these types w/ streams & pipelines.
//       Defering this until we extract a decodable-sdk-js
//       package, and keeping each domain's api type
//       definition file self-contained for now.
Object.defineProperty(exports, "__esModule", { value: true });
